import logger from './logger';

export const init = () => {
    const g = {
        key: 'AIzaSyBWZsZD9hXHJfVwN7EJZ3un0x8dx5y_-TM',
        v: 'quarterly',
    };
    var h,
        a,
        k,
        p = 'The Google Maps JavaScript API',
        c = 'google',
        l = 'importLibrary',
        q = '__ib__',
        m = document,
        b = window;
    b = b[c] || (b[c] = {});
    var d = b.maps || (b.maps = {}),
        r = new Set(),
        e = new URLSearchParams(),
        u = () =>
            h ||
            // eslint-disable-next-line
            (h = new Promise(async (f, n) => {
                await (a = m.createElement('script'));
                e.set('libraries', [...r] + '');
                for (k in g)
                    e.set(
                        k.replace(/[A-Z]/g, t => '_' + t[0].toLowerCase()),
                        g[k],
                    );
                e.set('callback', c + '.maps.' + q);
                a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
                d[q] = f;
                a.onerror = () => (h = n(Error(p + ' could not load.')));
                a.nonce = m.querySelector('script[nonce]')?.nonce || '';
                m.head.append(a);
            }));
    d[l]
        ? logger.warn(p + ' only loads once. Ignoring:', g)
        : (d[l] = (f, ...n) => {
              r.add(f);
              r.add('places');
              return u().then(() => d[l](f, ...n));
          });
};
